import { toast } from "react-toastify";
import { API_path } from "./apiPath";
import axiosInstance from "./axios";

const createOrder = async (orderDTO) => {
  console.log("orderDTO", orderDTO);
  let response; // Use 'let' instead of 'const'
  console.log("in above try");
  try {
    console.log("in try");
    response = await axiosInstance.post(API_path.createOrder, orderDTO);
    const responseData = response.data;
    if (
      responseData &&
      responseData.status &&
      responseData.paramObjectsMap.orderVO
    ) {
      console.log("in try if");
      toast.success(responseData.paramObjectsMap.message);
    } else {
      console.log("in try else");
      toast.error(responseData.paramObjectsMap.errorMessage);
    }
  } catch (error) {
    console.log("in catch");
    console.error("Error in createOrder:", error);
    toast.error("An error occurred while creating the Order.");
  }
  console.log("ser respo",response);
  return response;
};



const getOrdersData = async (branchId,orderType) => {
  let resOrders = [];
  try {
    const response = await axiosInstance.get(API_path.getOrders, {
      params: {
        branchId: branchId,
        orderType:orderType
      },
    });
    const responseDate = response.data;
    if (responseDate && responseDate.status) {
      // toast.success(responseDate.paramObjectsMap.message);
      resOrders = responseDate.paramObjectsMap.orderVO;
    } else {
      toast.error(responseDate.paramObjectsMap.errorMessage);
    }
  } catch (error) {
    console.log(error);
  }
  return resOrders;
};

const getStockDetails = async (branchId) => {
  let resStockDetails = [];
  try {
    const response = await axiosInstance.get(API_path.getStockDetails, {
      params: {
        branchId: branchId,
      },
    });
    const responseDate = response.data;
    if (responseDate && responseDate.status) {
      // toast.success(responseDate.paramObjectsMap.message);
      resStockDetails = responseDate.paramObjectsMap.stockDetails;
    } else {
      toast.error(responseDate.paramObjectsMap.errorMessage);
    }
  } catch (error) {
    console.log(error);
  }
  return resStockDetails;
};

export { createOrder ,getOrdersData,getStockDetails };
